import { render, staticRenderFns } from "./ComprometimentoAnexos.vue?vue&type=template&id=81bfbbba"
import script from "./ComprometimentoAnexos.vue?vue&type=script&lang=js"
export * from "./ComprometimentoAnexos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports